module.exports = __webpack_public_path__ + "static/media/image_3_3.ad16a6b8.svg";